import withStyles from 'react-jss';

import MobileMenu from './component';
import styles from './styles';

export default withStyles(styles)(MobileMenu);
